<template>
  <div class="alipay-flow-page">
    <div class="phone-screen">
      <img class="screen-image" :src="screenImage" alt="支付宝设置页面" />
      <button class="hotspot back-arrow" type="button" aria-label="返回上一页" @click="goBack" />
      <button class="hotspot account-security" type="button" aria-label="进入账户与安全" @click="goAccountSecurity" />
    </div>
  </div>
</template>

<script>
import screenImage from "@/assets/alipay-settings-page-no-status.png";

export default {
  name: "AlipaySettingsPage",
  data() {
    return { screenImage };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    goAccountSecurity() {
      this.$router.push({ name: "AlipayAccountSecurityPage" });
    },
  },
};
</script>

<style scoped>
.alipay-flow-page {
  min-height: 100vh;
  background: #eff2f7;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  box-sizing: border-box;
}
.phone-screen {
  position: relative;
  width: 100vw;
  height: 100vh;
}
.screen-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: fill;
}
.hotspot {
  position: absolute;
  border: none;
  background: transparent;
  cursor: pointer;
}
.back-arrow {
  left: 1.5%;
  top: 0.8%;
  width: 9%;
  height: 6%;
}
.account-security {
  left: 5%;
  top: 7.8%;
  width: 90%;
  height: 6%;
}
</style>
